import React from 'react';
import ListPage from '../../base/ListPage.js';
import APILXD from '../../../http/APILXD.js';
import { Modal, message, Popover, Descriptions, Tag, Button, Badge } from 'antd';
import HttpTool from "../../../tool/HttpTool";
import styles from "./index.less";
import ModalBase from "../../../components/modalBase";
import ModalDelete from "../../../components/modalDelete/ModalDelete";
import TimeHelp from "../../../tool/TimeHelp";
import dayjs from 'dayjs';
import AppreciationComboSet from "./component/AppreciationComboSet";
import MonthlyComboSet from "./component/MonthlyComboSet";
import VolumeComboSet from "./component/VolumeComboSet";
import Help from "../../../tool/Help";
import classNames from "classnames";

const MB = new ModalBase()
const MD = new ModalDelete()
const BuyTypeMap = {
  'package_pay': '增值',
  'month_pay': '按月',
  'per_use_pay': '按量',
}

export default class ServerPrice extends ListPage {
  constructor(props) {
    super(props);

    this.previewData = null;  //套餐预览数据
  }

  base_getListConfig() {
    return {
      table: {
        columns: this.getTableColumns(),
        url: APILXD.pricePackageGetList,
        otherParam: {
          productType: 'compute_power'
        },
      },
      new: {
        defaultValue: '新增服务器套餐',
        action: () => {
          this.add();
        }
      },
      search: {
        seniorSearch: this.getSeniorSearch(),
        option: {
          openSenior: true,
          placeholder: '请输入套餐名称搜索',
          reg: /^[\s\S]*$/,
          beforeSubmit: (value) => {
            if (value.keyword) {
              value.name = value.keyword
            }
            delete value.keyword
            if (value.enable) {
              value.enable = value.enable === 1
            }

            return true;
          },
        }
      }
    }
  }

  getSeniorSearch() {
    return {
      colCount: 3,
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18, offset: 0 },
      },
      parameterArr: [
        {
          field: "payType",
          name: "套餐类型",
          type: 'Select',
          selectType: 'value',
          reg: (v) => {
            return !!v
          },
          option: {
            allowClear: true,
          },
          data: Object.keys(BuyTypeMap).map((key) => {
            return {
              title: BuyTypeMap[key],
              value: key
            }
          })
        },
        {
          field: "enable",
          name: "状态",
          type: 'select',
          selectType: 'value',
          reg: (v) => {
            return true;
          },
          option: {
            allowClear: true,
          },
          data: [
            {
              title: '已上架',
              value: 1,
            },
            {
              title: '已下架',
              value: 2,
            },
          ]
        },
      ],
    }
  }

  validStepValue(data) {
    console.log('validStepValue', data);

    if (!data?.length || !data.filter((item) => {
      return !!item
    }).length) {
      message.warning("档位未设置");
      return false
    }

    let preItem = null;
    //第一段不是1
    if (data[0].startCount !== 1) {
      message.warning("起始值应该是数值1");
      return false
    }
    for (let i = 0; i < data.length; i++) {
      let current = data[i];
      if (!(typeof current.endCount === 'number' && typeof current.startCount === 'number' && typeof current.perN === 'number' && typeof current.cost === 'number')) {
        message.warning("档位未填写完成");
        return false
      }

      //起始值大于终点值
      if (current.startCount > current.endCount) {
        message.warning("档位起始值大于终点值");
        return false
      }

      //档位和每多少次不成比例
      if ((current.endCount - current.startCount + 1) < current.perN) {
        message.warning("档位区间值小于调用批量值");
        return false
      }

      //档位和每多少次不成比例
      if ((current.endCount - current.startCount + 1) % current.perN !== 0) {
        message.warning("档位区间值无法被调用批量值整除");
        return false
      }

      if (preItem) {
        //后一个端小于前一段
        if (current.startCount !== (preItem.endCount + 1)) {
          message.warning("档位衔接不正确");
          return false
        }
      }
      preItem = current;
    }

    return true
  }

  comboValid(param) {
    //根据不同套餐，设置不同字段
    switch (param.payType) {
      case "package_pay": {
        let ifValid = typeof param.comboSet1?.price === 'number' && typeof param.comboSet1?.month === 'number' && typeof param.comboSet1?.countNum === 'number' && typeof param.comboSet1?.agentNum === 'number';

        if (!ifValid) {
          return false
        } else {
          return {
            price: param.comboSet1?.price,
            monthLimit: param.comboSet1?.month,
            monthLimitUnit: '月',
            countLimit: param.comboSet1?.countNum,
            agentCountLimit: param.comboSet1?.agentNum,
          }
        }
      }
      case "month_pay": {
        let ifValid = typeof param.comboSet2?.price === 'number' && typeof param.comboSet2?.month === 'number' && typeof param.comboSet2?.countNum === 'number' && typeof param.comboSet2?.agentNum === 'number';

        if (!ifValid) {
          return false
        } else {
          return {
            price: param.comboSet2?.price,
            monthLimit: param.comboSet2?.month,
            monthLimitUnit: '月',
            countLimit: param.comboSet2?.countNum,
            agentCountLimit: param.comboSet2?.agentNum,
          }
        }
      }
      case "per_use_pay": {
        let ifValid = typeof param.comboSet3?.month === 'number' && this.validStepValue(param.comboSet3.countPrice) && this.validStepValue(param.comboSet3.agentPrice)

        if (!ifValid) {
          return false
        } else {
          let tierList = [];
          param.comboSet3.countPrice?.forEach((countItem) => {
            tierList.push({
              type: 'compute',
              cost: countItem.cost,
              perN: countItem.perN,
              startCount: countItem.startCount,
              endCount: countItem.endCount,
            })
          })

          param.comboSet3.agentPrice?.forEach((countItem) => {
            tierList.push({
              type: 'agent',
              cost: countItem.cost,
              perN: countItem.perN,
              startCount: countItem.startCount,
              endCount: countItem.endCount,
            })
          })

          return {
            price: param.comboSet3?.price,
            monthLimit: param.comboSet3?.month,
            monthLimitUnit: '月',
            tierList: tierList
          }
        }
      }
    }
  }

  getAddData(defaultData) {
    let defaultOption = {
      type: "input",
      ver: true,
      reg: /^[\S\s]{0,50}$/,
      verMessage: "请填写，最多50个字符",
      required: true,
    };

    let comboSetValue = {};
    this.previewData = {
      payType: defaultData?.payType || 'package_pay',
      name: defaultData?.name,
      remark: defaultData?.remark,
      tagList: defaultData?.tagList,
    };
    if (defaultData) {
      switch (defaultData.payType) {
        case "package_pay":
          comboSetValue = {
            price: defaultData.price,
            month: defaultData.monthLimit,
            countNum: defaultData.countLimit,
            agentNum: defaultData.agentCountLimit,
          }
          this.previewData.data = comboSetValue;
          this.previewData.comboSet1 = comboSetValue;
          break;
        case "month_pay":
          comboSetValue = {
            price: defaultData.price,
            month: defaultData.monthLimit,
            countNum: defaultData.countLimit,
            agentNum: defaultData.agentCountLimit,
          }
          this.previewData.data = comboSetValue;
          this.previewData.comboSet2 = comboSetValue;
          break;
        case "per_use_pay":
          let countPriceStep = [];
          let agentPriceStep = [];
          defaultData.tierList.forEach((item) => {
            if (item.type === "compute") {
              countPriceStep.push(item)
            } else {
              agentPriceStep.push(item)
            }
          })
          comboSetValue = {
            month: defaultData.monthLimit,
            countPrice: countPriceStep,
            agentPrice: agentPriceStep,
          }
          this.previewData.data = comboSetValue;
          this.previewData.comboSet3 = comboSetValue;
      }
    }



    let props = {
      colCount: 1,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 18, offset: 0 },
      },
      parameterArr: [
        {
          ...defaultOption,
          field: "payType",
          name: "套餐类型",
          type: 'Radio',
          reg: (v) => {
            return !!v
          },
          option: {
            disabled: !!defaultData,
            defaultValue: defaultData?.payType || 'package_pay'
          },
          data: Object.keys(BuyTypeMap).map((key) => {
            return {
              title: BuyTypeMap[key],
              value: key
            }
          }),
          onChange: (value, state, changeState) => {
            console.log(value);
            let newArr = state.parameterArr;
            newArr.forEach((obj) => {
              //这里故意使用 == ，判断数字1或字符串1
              if (obj.mark === 'comboSet1') {
                obj.field = value === 'package_pay' ? obj.mark : null;
              }
              if (obj.mark === 'comboSet2') {
                obj.field = value === 'month_pay' ? obj.mark : null;
              }
              if (obj.mark === 'comboSet3') {
                obj.field = value === 'per_use_pay' ? obj.mark : null;
              }
            });

            this.previewData.payType = value;

            changeState('parameterArr', newArr);
          }
        },
        {
          ...defaultOption,
          field: "name",
          name: "套餐名称",
          type: 'input',
          reg: /^[\S\s]{1,30}$/,
          verMessage: "请填写，最多30个字符",
          option: {
            maxLength: "30",
            defaultValue: defaultData?.name
          },
          onChange: (value, state, changeState) => {
            this.previewData.name = value;
          }
        },
        {
          ...defaultOption,
          field: "nameEn",
          name: "套餐名称（英文）",
          type: 'input',
          reg: /^[\S\s]{1,30}$/,
          verMessage: "请填写，最多50个字符",
          option: {
            maxLength: "50",
            defaultValue: defaultData?.nameEn
          },
          onChange: (value, state, changeState) => {
            this.previewData.nameEn = value;
          }
        },
        {
          ...defaultOption,
          mark: "comboSet1",
          field: (!defaultData?.payType || defaultData?.payType === 'package_pay') ? "comboSet1" : null,
          name: "增值套餐内容",
          type: 'diy',
          component: AppreciationComboSet,
          reg: (v) => {
            return true

            //触发太频繁，改成提交前校验
            // return typeof v.price === 'number' && typeof v.month === 'number' && typeof v.countNum === 'number' && typeof v.agentNum === 'number'
          },
          verMessage: "请检查套餐内容",
          option: {
            defaultValue: comboSetValue
          },
          onChange: (value, state, changeState) => {
            this.previewData.data = value;
            this.previewData.comboSet1 = value;
            this.previewData.comboSet2 = null;
            this.previewData.comboSet3 = null;
          }
        },
        {
          ...defaultOption,
          mark: "comboSet2",
          field: defaultData?.payType === 'month_pay' ? "comboSet2" : null,
          name: "按月套餐内容",
          type: 'diy',
          component: MonthlyComboSet,
          reg: (v) => {
            return true

            //触发太频繁，改成提交前校验
            // return typeof v.price === 'number' && typeof v.month === 'number' && typeof v.countNum === 'number' && typeof v.agentNum === 'number'
          },
          verMessage: "请检查套餐内容",
          option: {
            defaultValue: comboSetValue
          },
          onChange: (value, state, changeState) => {
            this.previewData.data = value;
            this.previewData.comboSet2 = value;
            this.previewData.comboSet1 = null;
            this.previewData.comboSet3 = null;
          }
        },
        {
          ...defaultOption,
          mark: "comboSet3",
          field: defaultData?.payType === 'per_use_pay' ? "comboSet3" : null,
          name: "按量套餐内容",
          type: 'diy',
          component: VolumeComboSet,
          extra: "注意：第一档起始值必须是1，每一档必须衔接。超出档位部分按最后一档规格计费。",
          reg: (v) => {
            return true;

            //触发太频繁，改成提交前校验
            // return typeof v.month === 'number' && this.validStepValue(v.countPrice) && this.validStepValue(v.agentPrice)
          },
          verMessage: "请检查套餐内容",
          option: {
            defaultValue: comboSetValue
          },
          onChange: (value, state, changeState) => {
            this.previewData.data = value;
            this.previewData.comboSet3 = value;
            this.previewData.comboSet1 = null;
            this.previewData.comboSet2 = null;
          }
        },
        {
          ...defaultOption,
          field: "targetTag",
          name: "适用用户",
          type: 'Select',
          selectType: 'value',
          reg: (v) => {
            return !!v
          },
          verMessage: "请选择适用用户",
          option: {
            defaultValue: defaultData?.targetTag ? {
              key: defaultData.targetTag,
              value: defaultData.targetTag,
            } : null
          },
          apiConfig: {
            url: APILXD.pricePackageTargetTag,
            fillObject: (json) => {
              return json?.map((item) => {
                return {
                  title: item.desc,
                  value: item.code
                }
              });
            }
          },
        },
        {
          ...defaultOption,
          field: "eventTimeSet",
          name: "套餐活动期",
          type: 'RangePicker',
          required: false,
          reg: () => {
            return true
          },
          option: {
            style: { width: "100%" },
            defaultValue: (defaultData && defaultData?.eventEndTime) ? [dayjs(defaultData?.eventStartTime), dayjs(defaultData?.eventEndTime)] : null,
            disabledDate: (value) => {
              if (!value) {
                return false;
              }
              let nowDate = new Date();
              return value.valueOf() < nowDate.valueOf() - 86400000;
            },
          }
        },
        {
          ...defaultOption,
          field: "tagList",
          name: "套餐标签",
          type: 'SelectAll',
          selectType: 'value',
          required: false,
          reg: (v) => {
            if (!v?.length) {
              return true
            }

            return !(v.some((item) => { return item.length > 5 }))
          },
          verMessage: "每个标签最多使用5个字符",
          option: {
            mode: 'tags',
            placeholder: "请输入标签内容",
            onSearch: (v) => {
            },
            defaultValue: defaultData?.tagList?.length ? defaultData?.tagList.map((name) => {
              return {
                label: name,
                value: name,
              }
            }) : null
          },
          onChange: (value, state, changeState) => {
            this.previewData.tagList = value;
          }
        },
        {
          ...defaultOption,
          field: "tagListEn",
          name: "套餐标签（英文）",
          type: 'SelectAll',
          selectType: 'value',
          required: false,
          reg: (v) => {
            if (!v?.length) {
              return true
            }

            return !(v.some((item) => { return item.length > 20 }))
          },
          verMessage: "每个标签最多使用20个字符",
          option: {
            mode: 'tags',
            placeholder: "请输入标签内容",
            onSearch: (v) => {
            },
            defaultValue: defaultData?.tagListEn?.length ? defaultData?.tagListEn.map((name) => {
              return {
                label: name,
                value: name,
              }
            }) : null
          },
          onChange: (value, state, changeState) => {
            this.previewData.tagListEn = value;
          }
        },
        {
          ...defaultOption,
          field: "remark",
          name: "套餐说明",
          type: 'TextArea',
          required: false,
          reg: (v) => {
            return true
          },
          option: {
            maxLength: "50",
            defaultValue: defaultData?.remark
          },
          onChange: (value, state, changeState) => {
            this.previewData.remark = value;
          }
        },
        {
          ...defaultOption,
          field: "remarkEn",
          name: "套餐说明（英文）",
          type: 'TextArea',
          required: false,
          reg: (v) => {
            return true
          },
          option: {
            maxLength: "50",
            defaultValue: defaultData?.remarkEn
          },
          onChange: (value, state, changeState) => {
            this.previewData.remarkEn = value;
          }
        },
        {
          ...defaultOption,
          field: "sort",
          name: "排序",
          type: "inputNumber",
          required: false,
          reg: () => {
            return true
          },
          option: {
            style: { width: "100%" },
            min: 1,
            precision: 0,
            defaultValue: defaultData?.sort
          }
        },
      ],
    };
    return {
      props,
      otherParam: null
    }
  }

  add(defaultValue) {
    let addData = this.getAddData(defaultValue);
    MB.show(
      {
        title: defaultValue ? "编辑服务器套餐" : "新增服务器套餐",
        okTitle: "确定",
        closeTitle: "取消",
        width: 1000,
        customBtns: <div>
          <Button size={"large"}
            type={"primary"}
            ghost={true}
            onClick={() => {
              this.previewAction()
            }}
          >
            预览</Button>
        </div>
      },
      addData.props
      ,
      {
        otherParam: defaultValue ? {
          _id: defaultValue._id,
          productType: 'compute_power'
        } : {
          productType: 'compute_power'
        },
        url: defaultValue ? APILXD.pricePackageEdit : APILXD.pricePackageAdd,
        beforeSubmit: (param) => {
          console.log("param", param)


          //提交前检查套餐内容格式是否正确
          let comboValidResult = this.comboValid(param)

          if (!comboValidResult) {
            message.warning("请检查套餐内容配置");
            return false;
          }

          Object.assign(param, comboValidResult)

          //设置了活动期限
          if (param.eventTimeSet?.length) {
            param.eventStartTime = dayjs(param.eventTimeSet[0]).valueOf();
            param.eventEndTime = dayjs(param.eventTimeSet[1]).valueOf();
          }

          if (param.tagList?.length) {
            param.tagList = param.tagList.map((item) => {
              return typeof item === "string" ? item : item.value;
            });
          }
          if (param.tagListEn?.length) {
            param.tagListEn = param.tagListEn.map((item) => {
              return typeof item === "string" ? item : item.value;
            });
          }

          return true;
        },
        callBack: (state, msg) => {
          //添加成功回调
          state == 'success' && this._loadDataForNet();
        }
      });
  }

  //预览套餐
  previewAction() {
    if (!this.previewData) {
      message.warning("请先配置套餐数据")
      return;
    }

    let comboValidResult = this.comboValid(this.previewData)

    console.log('this.previewData', this.previewData)
    console.log('comboValidResult', comboValidResult)
    if (!comboValidResult) {
      message.warning("请检查套餐内容配置");
      return false;
    }

    let view = null;
    let boxWidth = 600;


    switch (this.previewData.payType) {
      case 'package_pay':
      case 'month_pay': {
        boxWidth = 350;
        view = <>
          <div className={styles.title} style={{ textAlign: 'center' }}>
            {this.previewData.payType === 'month_pay' ? `${this.previewData.data?.month}个月` : this.previewData?.name}
          </div>
          <div className={styles.ln} style={{ display: 'flex', alignItems: 'center' }}>
            <img src={require('../../../images/serverPrice/lingneng.png')} alt="" />
            {this.previewData.data.price / 100}
            <span style={{ fontSize: '16px' }}>灵能</span>
          </div>

          <div className={styles.countLimit} style={{ marginTop: '20px' }}>
            <img src={require('../../../images/serverPrice/fuwxmip6xz5-Frame_6.png')} alt="" />
            服务器上线 {comboValidResult?.countLimit} 次
          </div>
          <div className={styles.countLimit}>
            <img src={require('../../../images/serverPrice/fuwxmip6xz5-Frame_6.png')} alt="" />
            Agent上限 {comboValidResult?.agentCountLimit} 次
          </div>

          {this.previewData?.remark && (
            <p className={styles.desc} style={{ textAlign: 'center' }}>
              {this.previewData?.remark}
            </p>
          )}
        </>;
        break;
      }
      case 'per_use_pay': {
        view = <div style={{ padding: '0 16px', width: '100%' }}>
          <div className={styles.perUsePayTitle}>
            <span className={styles.message}>计费说明</span>
            <span className={styles.billing}>{`计费周期 ${this.previewData.data?.month}个月`}</span>
          </div>
          <div className={styles.perUsePayContent}>
            {/* 算力 */}
            <div className={classNames(styles.perUsePayContentItem, styles.perUsePayContentComputeItem)}>
              <p>算力调用档位</p>
              {this.previewData.data?.countPrice?.map((item, index) => {
                return (
                  <p key={index} style={{ fontWeight: '500' }}>
                    <span>{`${item?.startCount} ~ ${item?.endCount}`}</span>
                    <span>{`${item?.cost / 100}灵能/${item.perN}次`}</span>
                  </p>
                );
              })}
            </div>
            {/* Agent */}
            <div className={classNames(styles.perUsePayContentItem)}>
              <p>Agent 调用档位</p>
              {this.previewData.data?.agentPrice?.map((item, index) => {
                return (
                  <p key={index} style={{ fontWeight: '500' }}>
                    <span>{`${item?.startCount} ~ ${item?.endCount}`}</span>
                    <span>{`${item?.cost / 100}灵能/${item.perN}次`}</span>
                  </p>
                );
              })}
            </div>
          </div>

          {this.previewData?.remark && (
            <p className={styles.desc} style={{ textAlign: 'center' }}>
              {this.previewData?.remark}
            </p>
          )}
        </div>;
        break;
      }
    }

    Modal.info({
      title: "套餐预览",
      width: boxWidth,
      content: this.previewData.tagList?.length ? <Badge.Ribbon text={this.previewData.tagList[0]} color={"darkorange"}>
        <div
          className={classNames(styles.priceItem, styles.priceItemChecked)}
        >
          {view}
        </div>
      </Badge.Ribbon> : <div
        className={classNames(styles.priceItem, styles.priceItemChecked)}
      >
        {view}
      </div>,
    })
  }

  showPricePackageDetail(record) {
    switch (record.payType) {
      case 'package_pay':
        return <div
          style={{ width: 200 }}
        >
          <div>有效期：{Help.getDurationTimeShow(record.monthLimit, record.monthLimitUnit)}</div>
          <div>算力调用次数：{record.countLimit}</div>
          <div>Agent调用次数：{record.agentCountLimit}</div>
        </div>
      case 'month_pay':
        return <div
          style={{ width: 200 }}
        >
          <div>套餐时长：{Help.getDurationTimeShow(record.monthLimit, record.monthLimitUnit)}</div>
          <div>算力调用上限：{record.countLimit}</div>
          <div>Agent调用上限：{record.agentCountLimit}</div>
        </div>
      case 'per_use_pay':
        let countStep = [];
        let agentStep = [];
        record.tierList?.forEach((item, index) => {
          if (item.type === "compute") {
            countStep.push(item);
          } else {
            agentStep.push(item);
          }
        })

        return <div
          style={{ width: 200 }}
        >
          <div>计费周期：{Help.getDurationTimeShow(record.monthLimit, record.monthLimitUnit)}</div>
          <div>
            算力梯度：
            {countStep.map((item, index) => {
              return <div key={'t_' + index}>{`${item.startCount}~${item.endCount}次，每${item.perN}次 ${item.cost / 100}灵能`}</div>
            })}
          </div>
          <div>
            Agent梯度：
            {agentStep.map((item, index) => {
              return <div key={'t_' + index}>{`${item.startCount}~${item.endCount}次，每${item.perN}次 ${item.cost / 100}灵能`}</div>
            })}
          </div>
        </div>
    }
  }

  /**
   *  列表数据配置
   */
  getTableColumns() {
    return [
      {
        title: '套餐名称',
        dataIndex: 'name',
        key: 'name',
        width: '250px',
        render: (text, record) => {
          return <Popover
            content={<div
              style={{ maxWidth: '50vw', overflow: 'auto', wordBreak: 'break-all' }}
            >
              {text || "无"}
            </div>}
          >
            <div style={{ position: 'relative', minWidth: 150 }}>
              <div style={{ position: 'absolute', top: -20, left: 0, right: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>中文:{text}</div>
              <div style={{ position: 'absolute', top: 5, left: 0, right: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>英文:{record.nameEn || <span style={{ color: "red" }}>未填写</span>}</div>
            </div>
          </Popover>
        }
      },
      {
        title: '类型',
        dataIndex: 'payType',
        key: 'payType',
        render: (v) => {
          return BuyTypeMap[v]
        }
      },
      {
        title: '价格(灵能)',
        dataIndex: 'price',
        key: 'price',
        render: (text, record) => {
          return text ? text / 100 : 0
        }
      },
      {
        title: '详情',
        dataIndex: 'detail',
        key: 'detail',
        width: 200,
        render: (text, record, index) => {
          return this.showPricePackageDetail(record)
        }
      },
      {
        title: '活动范围',
        dataIndex: 'duration',
        key: 'duration',
        render: (text, record, index) => {
          return <div>
            <div>适用用户：{record.targetTagDesc}</div>
            <div>期限：{record.eventEndTime ? <span>
              {TimeHelp.getYMDFormat(record.eventStartTime, 'yyyy.MM.dd')}
              -
              {TimeHelp.getYMDFormat(record.eventEndTime, 'yyyy.MM.dd')}
            </span> : <span>无限期</span>}</div>
          </div>
        }
      },
      {
        title: '标签',
        dataIndex: 'tagList',
        key: 'tagList',
        render: (text) => {
          return <div style={{ maxWidth: '350px' }}>
            {
              text?.map((str) => {
                return <Tag key={str}>{str}</Tag>
              }) || '-'
            }
          </div>
        }
      },
      {
        title: '标签(英文)',
        dataIndex: 'tagListEn',
        key: 'tagListEn',
        render: (text) => {
          return <div style={{ maxWidth: '350px' }}>
            {
              text?.map((str) => {
                return <Tag key={str}>{str}</Tag>
              }) || '-'
            }
          </div>
        }
      },
      {
        title: '排序',
        dataIndex: 'sort',
        key: 'sort',
        width: 90,
        render: (text) => {
          return text ?? '-'
        }
      },
      {
        title: '状态',
        dataIndex: 'enable',
        key: 'enable',
        render: (text) => {
          return text ? <span style={{ color: 'dodgerblue' }}>已上架</span> :
            <span style={{ color: 'darkorange' }}>已下架</span>
        }
      },
      {
        title: '已售数量',
        dataIndex: 'count',
        key: 'count',
        render: (text) => {
          return text || 0
        }
      },
      {
        title: '操作',
        width: 220,
        render: (text, record, index) => {
          return (
            <div>
              {
                this.powerConfig.Edit
                  ? (record.enable ? <span onClick={() => {
                    this.changeState(record, false)
                  }} style={{ color: "darkorange" }} className={styles.btnCopy}>{"下架"}</span> :
                    <span onClick={() => {
                      if (record.eventEndTime && Date.now() >= record.eventEndTime) {
                        Modal.info({
                          title: "提示",
                          content: "该套餐已过活动有效期，请重新设置后再上架"
                        })
                        return;
                      }

                      if (record.eventStartTime && Date.now() < record.eventStartTime) {
                        Modal.info({
                          title: "提示",
                          content: "该套餐设置了活动有效期，有效期内会自动上架，无需手动调整。"
                        })
                        return;
                      }

                      this.changeState(record, true)
                    }} style={{ color: "dodgerblue" }} className={styles.btnEdit}>{"上架"}</span>)
                  : null
              }
              {
                this.powerConfig.Edit
                  ? <span onClick={() => {
                    this.add(record)
                  }} className={styles.btnEdit}>{"修改"}</span>
                  : null
              }
              {
                this.powerConfig.Delete && !record.enable
                  ? <span onClick={() => {
                    MD.show({
                      title: "提示",
                      okTitle: "确定",
                      closeTitle: "取消",
                    },
                      {}
                      ,
                      {
                        otherParam: { _id: record._id },
                        content: record.name,
                        url: APILXD.pricePackageDel,
                        apiType: 'post',
                        callBack: (state) => {
                          //删除成功回调
                          if (state === "success") {
                            if (this.items?.length === 1 && this.state.page > 1) {
                              //当前页的最后一条
                              this.setState({
                                page: this.state.page - 1
                              }, () => {
                                this._loadDataForNet();
                              })
                            } else {
                              this._loadDataForNet();
                            }
                          }
                        }
                      });
                  }} className={styles.btnDelete}>{"删除"}</span>
                  : null
              }
            </div>
          )
        }
      },
    ]
  }

  changeState(record, enable) {
    Modal.confirm({
      title: '提示',
      content: enable
        ? <div>
          <div>确定上架服务器套餐：{record.name} 吗？</div>
          <div style={{ opacity: 0.65, fontSize: 12 }}>上架后用户可以购买该套餐，请谨慎操作。</div>
        </div>
        : <div>
          <div>确定下架服务器套餐：{record.name} 吗？</div>
          <div style={{ opacity: 0.65, fontSize: 12 }}>下架后用户将不能购买该套餐，请谨慎操作。</div>
        </div>,
      okText: '确定',
      cancelText: '取消',
      onOk: () => {
        let param = {
          _id: record._id,
          enable: enable,
        };
        let successCB = (code, msg, json, option) => {
          this.setState({ loading: false }, () => {
            message.success('操作成功');
            this._loadDataForNet();
          });
        };
        let failureCB = (code, msg) => {
          this.setState({ loading: false }, () => {
            message.error(msg);
          });
        };

        this.setState({ loading: true });

        HttpTool.post(APILXD.pricePackageDisable, successCB, failureCB, param);
      }
    })
  }
}
